// This file is autogenerated. Please don't modify it directly. See the README for details
/* tslint:disable */
const enum MiniMailIcons {
    Accounts = 'Accounts',
    ContactCard = 'ContactCard',
    DietPlanNotebook = 'DietPlanNotebook',
    DoubleChevronDown = 'DoubleChevronDown',
    DoubleChevronUp = 'DoubleChevronUp',
    Down = 'Down',
    Drm = 'Drm',
    Error = 'Error',
    FabricMovetoFolder = 'FabricMovetoFolder',
    Fax = 'Fax',
    Filter = 'Filter',
    Flag = 'Flag',
    History = 'History',
    Important = 'Important',
    Label = 'Label',
    Like = 'Like',
    MailForward = 'MailForward',
    Memo = 'Memo',
    More = 'More',
    NotePinned = 'NotePinned',
    OpenFolderHorizontal = 'OpenFolderHorizontal',
    OutOfOffice = 'OutOfOffice',
    Phishing = 'Phishing',
    Pinned = 'Pinned',
    PinnedSolid = 'PinnedSolid',
    QuickNote = 'QuickNote',
    Read = 'Read',
    ReceiptCheck = 'ReceiptCheck',
    ReceiptForward = 'ReceiptForward',
    ReceiptReply = 'ReceiptReply',
    RecurringTask = 'RecurringTask',
    Reply = 'Reply',
    ReplyAll = 'ReplyAll',
    Ringer = 'Ringer',
    VoicemailForward = 'VoicemailForward',
    VoicemailReply = 'VoicemailReply',
    Zoom = 'Zoom',
}

export default MiniMailIcons;
